/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

import {
  estimateBill,
  estimateBasicFee,
  estimateUploadData,
  estimateDataTransfer,
} from "common/utils";

function PricingCards() {
  const [dayNumber, setDayNumber] = useState(0);
  const [siteNumber, setSiteNumber] = useState(0);
  return (
    <MDBox mt={8}>
      <MDBox textAlign="center">
        <MDTypography variant="h6" opacity={0.5}>
          Estimate your bill
        </MDTypography>
      </MDBox>
      <MDBox mt={5} ml={{ xs: 0, lg: 0 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={12} lg={12}>
            If you activate to the General plan and use{" "}
            <MDInput
              type="number"
              label="Days"
              onChange={(e) => setDayNumber(Number(e.target.value))}
            />{" "}
            days upload data and{" "}
            <MDInput
              type="Number"
              label="Data points"
              onChange={(e) => setSiteNumber(Number(e.target.value))}
            />{" "}
            data points, Your bill will be US$ {estimateBill(siteNumber, dayNumber)} per month.
            Details are Basic fee US$ {estimateBasicFee(siteNumber)}, upload data US${" "}
            {estimateUploadData(dayNumber)}, Data transfer charge US${" "}
            {estimateDataTransfer(dayNumber)}.
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
}

export default PricingCards;
